import {useDispatch} from "react-redux";
import ModalBody from "../../../core/Modal/ModalBody/ModalBody";
import ModalHeader from "../../../core/Modal/ModalHeader/ModalHeader";
import {closeLobbyModal} from "../../../redux/actions/lobby/actions";
import Settings from "../Settings/Settings";
import {useTranslation} from "react-i18next";

function SettingsModal() {
    const dispatch = useDispatch()
    const {t} = useTranslation();

    return <>
        <ModalHeader>
            <div className="settings-modal-header">
                <p>{t("mobile_side_menu.settings")}</p>
                <i className="icon-close" onClick={() => dispatch(closeLobbyModal())}/>
            </div>
        </ModalHeader>
        <ModalBody>
            <Settings/>
        </ModalBody>
    </>
}

export default SettingsModal